<template>
  <v-card outlined>
    <v-toolbar class="elevation-0" height="45" color="gray">
      <v-toolbar-title>
        <h1 class="subtitle-1">{{ $t("labels.softwareInformation") }}</h1>
      </v-toolbar-title>
    </v-toolbar>
    <v-card-text>
      <v-layout column>
        <v-layout row wrap>
          <v-flex>{{ $t("labels.software") }}</v-flex>
          <v-spacer> </v-spacer>
          <v-flex class="font-weight-regular text-right" v-if="service.pos.cSoftware">
            {{ service.pos.cSoftware.selector }}</v-flex
          >
          <v-flex class="font-weight-regular text-right" v-else>Not Selected</v-flex>
        </v-layout>
        <v-divider> </v-divider>
        <v-layout row wrap>
          <v-flex>{{ $t("labels.plan") }}</v-flex>
          <v-spacer> </v-spacer>
          <v-flex class="font-weight-regular text-right">{{
            service.pos.Product.productDetail
          }}</v-flex>
        </v-layout>
        <v-divider> </v-divider>
        <v-layout row wrap>
          <v-flex>{{ $t("labels.monthly") }}</v-flex>
          <v-spacer> </v-spacer>
          <v-flex class="font-weight-regular text-right">{{
            service.pos.softwareFee | currency
          }}</v-flex>
        </v-layout>
        <v-divider> </v-divider>
        <v-layout row wrap>
          <v-flex>{{ $t("labels.currentVersion") }}</v-flex>
          <v-spacer> </v-spacer>
          <v-flex class="font-weight-regular text-right">{{
            location.softwareCurrentVersion
          }}</v-flex>
        </v-layout>
        <v-divider> </v-divider>
        <v-layout row wrap>
          <v-flex>{{ $t("labels.versionLimit") }}</v-flex>
          <v-spacer> </v-spacer>
          <v-flex class="font-weight-regular text-right">{{
            location.UpdateSoftwareVersion
          }}</v-flex>
        </v-layout>
      </v-layout>
    </v-card-text>
  </v-card>
</template>

<script>
import { mapActions, mapGetters } from "vuex";
import locationService from "../../service.js";

const { validationMixin } = require("vuelidate");
const { required, minLength, minValue } = require("vuelidate/lib/validators");

export default {
  data() {
    return {
      isLoading: true,
      transactionDialog: false,
      showIpAddress: false,
      softwareProduct: [],
      editLocation: null
    };
  },
  methods: {
    ...mapActions("location", ["setLocation"]),
    close() {
      this.dialog = false;
    },
    update() {
      let editData = {
        cSoftwareID: this.editLocation.cSoftwareID,
        productID: this.editLocation.productID,
        softwareFee: this.editLocation.softwareFee
      };
      return locationService
        .updateProductRelation(
          this.editLocation.storeID,
          this.service.pos.serviceID,
          this.editLocation
        )
        .then(result => {
          this.$swal
            .mixin({
              toast: true,
              position: "top-end",
              showConfirmButton: false,
              timer: 3000
            })
            .fire({
              type: "success",
              title: "Update Successfully"
            });
          this.close();
          this.setLocation(this.editLocation.storeID);
        });
    },
    openTransaction() {
      this.transactionDialog = true;
    },
    closeTransaction() {
      this.transactionDialog = false;
    },
    getIpAddressList() {
      this.showIpAddress = true;
    },
    getServiceProduct() {
      return locationService.getServiceProduct(this.service.pos.serviceID).then(result => {
        console.log("product", result);
        this.softwareProduct = result.data;
      });
    }
  },
  watch: {
    dialog(val) {
      if (val) {
        this.getServiceProduct();
        this.editLocation = _.clone(this.location);
        this.isLoading = false;
      }
    }
  },
  mixins: [validationMixin],
  validations: {
    editLocation: {
      cSoftwareID: {
        required,
        minValue: minValue(1)
      },
      productID: {
        required,
        minValue: minValue(1)
      },
      softwareFee: {
        required
      }
    }
  },
  computed: {
    ...mapGetters("location", ["location", "service"]),
    ...mapGetters("global", ["comboBoxByID"]),
    softwareErrors() {
      const errors = [];
      if (!this.$v.editLocation.cSoftwareID.$dirty) return errors;
      if (!this.$v.editLocation.cSoftwareID.required)
        errors.push(this.$t("validations.fieldIsRequired"));
      return errors;
    },
    productErrors() {
      const errors = [];
      if (!this.$v.editLocation.productID.$dirty) return errors;
      if (!this.$v.editLocation.productID.required)
        errors.push(this.$t("validations.fieldIsRequired"));
      return errors;
    },
    softwareFeeErrors() {
      const errors = [];
      if (!this.$v.editLocation.softwareFee.$dirty) return errors;
      if (!this.$v.editLocation.softwareFee.required)
        errors.push(this.$t("validations.fieldIsRequired"));
      return errors;
    }
  }
};
</script>

<style scoped></style>
